module.exports = __webpack_public_path__ + "montserrat-extrabolditalic-webfont.de0ee0f6ec0ff921806b.woff";


//////////////////
// WEBPACK FOOTER
// D:/Honda/Trunk/WizdomWebApp/Wizdom-Web-App/src/assets/fonts/montserrat-extrabolditalic-webfont.woff
// module id = ../../../../../src/assets/fonts/montserrat-extrabolditalic-webfont.woff
// module chunks = styles